module.exports = __webpack_public_path__ + "static/img/tailored.1016e70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Fertimo/tailored.png
// module id = 1le0
// module chunks = 1